import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const WSZ_ENDPOINT = 'node';
export const WSZ_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WSZ_ENDPOINT);


export const wszStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
